require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-claptone-after-parties-amazon-pastries.json") })
        }
      }, "path---interview-claptone-after-parties-amazon-pastries");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-claptone-after-parties-amazon-pastries!./.cache/json/interview-claptone-after-parties-amazon-pastries.json
// module id = 662
// module chunks = 231608221292675